import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "app/services/abstract.service";
import { DocumentTypeAttributes } from "@albatrosdeveloper/ave-models-package";
import { ICreateDocumentType } from "./interfaces/create-document-type.interface";
import { IUpdateDocumentType } from "./interfaces/update-document-type.interface";
import { IFilters } from "../../filters/interfaces/filterInterface";
const apiUrl = env.API_DOCUMENT_URL;
const moduleName = "document_type";

@Injectable({
  providedIn: "root",
})
export class DocumentTypeService extends AbstractService<
  DocumentTypeAttributes,
  ICreateDocumentType,
  IUpdateDocumentType
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<DocumentTypeAttributes>,
    dataToFilter?: IFilters
  ): Observable<IPaginationResult<DocumentTypeAttributes>> {
    const query = buildQuery<DocumentTypeAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("code", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      dataToFilter?.status && dataToFilter.status.length > 0
        ? andAllWhere(
          "statusId" as keyof DocumentTypeAttributes, Ops.in(...dataToFilter.status)
        )
        : noop(),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<DocumentTypeAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<DocumentTypeAttributes[]>> {
    const query = buildQuery<DocumentTypeAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["externalKeys","code", "name"]),
      orderBy("code", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<DocumentTypeAttributes[]>>(API_URL);
  }

   /**
     * Find to related material
     * @returns Data
     */
    findToRelated(
      typeIds: string[]
    ): Observable<IRequestResult<DocumentTypeAttributes[]>> {
      const query = buildQuery<DocumentTypeAttributes>(
        where("_deleted", Ops.eq(false)),
        typeIds && typeIds.length > 0
          ? andAllWhere("code" as keyof DocumentTypeAttributes, Ops.in(...typeIds))
          : noop()
      );
  
      const API_URL: string =
        apiUrl +
        `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
      return this.http.get<IRequestResult<DocumentTypeAttributes[]>>(API_URL);
    }
}
